import { render, staticRenderFns } from "./SnigelExpAdUnit.vue?vue&type=template&id=46e55859&scoped=true"
import script from "./SnigelExpAdUnit.vue?vue&type=script&setup=true&lang=ts"
export * from "./SnigelExpAdUnit.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SnigelExpAdUnit.vue?vue&type=style&index=0&id=46e55859&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e55859",
  null
  
)

export default component.exports